import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { ToggleModule } from 'src/app/project/components/toggle/toggle.module';
import { TooltipsModule } from 'src/app/project/features/tooltip/tooltips.module';
import { EGoogleEventLabel } from 'src/app/project/services/analytics/google-analytics.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';
import { TCustomFieldAccessOption, TShare } from '../../../share.model';
import { EAccessParameter } from '../access-parameters';
import { ShareEditService } from '../share-edit.service';

@Component({
  selector: 'pp-share-edit-relationships',
  imports: [PipesModule, TooltipsModule, ToggleModule],
  templateUrl: './share-edit-relationships.component.html',
  styleUrl: './share-edit-relationships.component.scss',
})
export class ShareEditRelationshipsComponent {
  @Input() ppShare: TShare;
  @Input() ppWorkspaceId: string;
  @Output() ppChange = new EventEmitter<void>();
  @Output() ppShareChange = new EventEmitter<TShare>();
  @Input() ppDisabled: boolean;

  EIconPath = EIconPath;
  EGoogleEventLabel = EGoogleEventLabel;
  accessParameters = EAccessParameter;

  constructor(private shareEditService: ShareEditService) {}

  correctProperty(
    property: EGoogleEventLabel,
    parameter?: EAccessParameter,
    field?: TCustomFieldAccessOption,
  ): void {
    if (this.ppDisabled) {
      return;
    }

    this.ppShare = this.shareEditService.correctProperty({
      workspaceId: this.ppWorkspaceId,
      share: this.ppShare,
      property,
      parameter,
      field,
    });

    this.ppChange.emit();
  }
}
